export const defaultAngleLinesValue = () => {
    return {
        box_styles:{
            width:250,
            height:250,
        },
        line_styles: { 
            bg_color: "#656d4a",
        },
        angle_start:0,
        angle_between:0,
        line_stroke_width : 4,
        line_length : 100,
        pivot_radius : 6
    };
}

